/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export enum ProductionSpeedTypeEnum {
    "hsp" = "hsp",
    "standard" = "standard"
}

export type ProductionSpeedType = ProductionSpeedTypeEnum;